import * as React from 'react';
import { AccessDenied } from './index';

export function AccessDeniedToPage() {
  return (
    <AccessDenied translationKeySuffix='PAGE' />
  );
}
